export const loaderWidth = '100px';
export const loaderHeight = loaderWidth;
